import { apiGet, apiPost } from '../../framework/client';
import { ERROR_API_CALL_FAILED } from '../../../common/framework/constants';
import { AddMonthlySalesInvoiceReq } from '../../../common/application/model/api/AddMonthlySalesInvoiceReq';
import { AddMonthlySalesInvoiceResp } from '../../../common/application/model/api/AddMonthlySalesInvoiceResp';
import { AddNextMonthlySalesInvoiceResp } from '../../../common/application/model/api/AddNextMonthlySalesInvoiceResp';
import { AddNextMonthlySalesInvoiceReq } from '../../../common/application/model/api/AddNextMonthlySalesInvoiceReq';
import { AddBalanceInvoiceReq } from '../../../common/application/model/api/AddBalanceInvoiceReq';
import { AddBalanceInvoiceResp } from '../../../common/application/model/api/AddBalanceInvoiceResp';
import { VehicleContract } from '../../../common/application/model/VehicleContract';
import { SalesInvoiceRow } from '../../../common/application/model/SalesInvoiceRow';

export async function postMonthlySalesInvoiceRequest(
    addMonthlySalesInvoiceReq: AddMonthlySalesInvoiceReq,
): Promise<AddMonthlySalesInvoiceResp> {
    const response = await apiPost('/api/sales-invoice/add-monthly', addMonthlySalesInvoiceReq);
    if (response.status === 200) {
        return (await response.json()) as AddMonthlySalesInvoiceResp;
    } else {
        throw new Error(ERROR_API_CALL_FAILED);
    }
}

export async function postBalanceInvoiceRequest(
    addBalanceInvoiceReq: AddBalanceInvoiceReq,
): Promise<AddBalanceInvoiceResp> {
    const response = await apiPost('/api/balance-invoice/add', addBalanceInvoiceReq);
    if (response.status === 200) {
        return (await response.json()) as AddBalanceInvoiceResp;
    } else {
        throw new Error(ERROR_API_CALL_FAILED);
    }
}

export async function postNextMonthlySalesInvoiceRequest(
    addNextMonthlySalesInvoiceReq: AddNextMonthlySalesInvoiceReq,
): Promise<AddNextMonthlySalesInvoiceResp> {
    const response = await apiPost('/api/sales-invoice/add-next-monthly', addNextMonthlySalesInvoiceReq);
    if (response.status === 200) {
        return (await response.json()) as AddNextMonthlySalesInvoiceResp;
    } else {
        throw new Error(ERROR_API_CALL_FAILED);
    }
}

export async function getContractsForRetroactiveInvoicing(
    customerIds?: string[],
): Promise<(VehicleContract & { salesInvoiceRows: SalesInvoiceRow[] })[]> {
    const response = await apiGet(
        `/api/resource/retroactive-sales-invoice${customerIds ? '?customerIdIn=' + customerIds : ''}`,
    );
    if (response.status === 200) {
        return (await response.json()) as (VehicleContract & { salesInvoiceRows: SalesInvoiceRow[] })[];
    } else {
        throw new Error(ERROR_API_CALL_FAILED);
    }
}
